<template>
  <v-main>
    <navigation v-if="!liffUser"/>
    <guide-tour :config-key="`care.${$router.currentRoute.name}`"/>
    <v-card-subtitle v-if="$router.currentRoute.name === 'careProgressPending'" class="py-0 grey-7--text">
      點我前往<router-link :to="{ name: 'CareTemplateList' }" target="_blank" class="link_blue--text">術後關懷設定</router-link>頁面
    </v-card-subtitle>

    <v-tabs v-model="tab" right>
      <v-tab to="/post-operative-care/progress/unprocessed">待處理</v-tab>
      <v-tab to="/post-operative-care/progress/processed">已處理</v-tab>
      <v-tab to="/post-operative-care/progress/pending">訊息排程管理</v-tab>
    </v-tabs>
    <router-view/>
  </v-main>
</template>

<script>
import Navigation from "@/components/Navigation";
import { mapGetters } from "vuex";
import GuideTour from "@/components/utils/GuideTour.vue";

export default {
  name: "ProgressIndex",
  components: { GuideTour, Navigation },
  computed: {
    ...mapGetters(["liffUser"]),
    tab: {
      get() {
        const path = this.$route.path;
        if (path.includes('/pending')) return 0;
        if (path.includes('/unprocessed')) return 1;
        if (path.includes('/processed')) return 2;
        return 0;
      },
      set() {}
    },
  },
};
</script>
